import React from "react";
import PropTypes from "prop-types";
import { Row, Radio } from "antd";

export const maxNumMonthElements = (reportType) => {
  switch (reportType) {
    case "Bi-Annually":
      return 6;
    case "Quarterly":
      return 3;
    default:
      return 0;
  }
};

const generateOptions = (num) => {
  const optionSet = [];
  for (let index = 0; index < num; index++) {
    optionSet.push(
      <Radio.Button key={`_${index}`} value={index + 1}>
        Month {index + 1}
      </Radio.Button>,
    );
  }
  return optionSet;
};

const QuarterlyMonth = (props) => {
  const { value, onChange, monthCount } = props;
  return (
    <Row justify="center">
      <Radio.Group value={value} buttonStyle="solid" onChange={onChange}>
        {generateOptions(monthCount)}
      </Radio.Group>
    </Row>
  );
};

QuarterlyMonth.defaultProps = {
  monthCount: 3,
  onChange: () => {},
};

QuarterlyMonth.propTypes = {
  value: PropTypes.string.isRequired,
  monthCount: PropTypes.number,
  onChange: PropTypes.func,
};

export default QuarterlyMonth;
